<div class="{{theme}}">
    <div mat-dialog-title>
        <div class="row">
            <div class="col-md-10">
                <h3 *ngIf="!disclaimer.disclaimerId">Add Disclaimer</h3>
                <h3 *ngIf="disclaimer.disclaimerId">Edit Disclaimer</h3>
            </div>
            <div class="col-md-2">
                <span class="fa fa-close action-icons float-right ml-auto" (click)="close()"></span>
            </div>
        </div>
    </div>
    <div mat-dialog-content class="mat-dialog-content">
        <div class="row">
            <div class="col-md-12 mt-2">
                <div class="row" *ngFor="let alert of alerts" class="padding-b-15">
                    <div class="alert alert-dismissible" [ngClass]="{'alert-danger': alert.type === 'error','alert-success': alert.type === 'success'}">
                        <button type="button" class="close" data-dismiss="alert" (click)="closeAlerts()">×</button>
                        {{ alert.msg }}
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-12">
            <mat-form-field class="example-full-width">
                <input matInput placeholder="Disclaimer Title" [(ngModel)]="disclaimer.disclaimerTitle" required name="disclaimerTitle" value="">
            </mat-form-field>
        </div>
        <div class="col-md-12">
            <mat-form-field class="example-full-width">
                <textarea matInput class="row col-md-12 notes-text-area" [(ngModel)]="disclaimer.disclaimerMessage" name="disclaimerMessage"
                    rows="4" placeholder="Disclaimer">
     </textarea>
            </mat-form-field>
        </div>
    </div>
    <div mat-dialog-actions class="dialog-actions">
        <span>
            <button class="btn btn-default" (click)="onSelect()">Ok</button>
        </span>
        <span class="ml-2">
            <button class="btn btn-secondary" (click)="onCancel()">Cancel</button>
        </span>
    </div>
</div>